module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID:
      "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  // API_URL: "http://43.204.193.95:7777/api/",
  // API_URL:"http://43.204.193.95:8888/api/"
  // API_URL: "http://localhost:7777/api/",
  // API_URL:"http://192.168.29.169:7777/api",
  // API_URL: "http://192.168.29.230:7777/api",
  API_URL: "https://adminapi.zeronine.ai/api/",
};
